import {styled} from "@mui/material";

const Header = styled("div")(
    ({withDivider, dividerColor}: { withDivider?: boolean; dividerColor?: string }) => ({
        display: "flex",
        justifyContent: "space-between",
        padding: "12px 24px",
        ...(withDivider && {
            borderBottom: `2px solid ${dividerColor || "#F6F6FA"}`,
        }),
    })
);

export default Header;
